import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { formatCustomDate, formatDateToLexicographicalOrder, updateYAxisTitle } from '../AnalyticsHelper';
import { DEFAULT_HEIGHT, PREVIOS_PERIOD, PT2H } from '../AnalyticsConstants';
import { ApexOptions } from 'apexcharts';
import moment from 'moment';
const SynchronizedChartItem = ({ id, type, data, xAxis, granularity, metricName, timezone } : any) => {
    const colors = id === PREVIOS_PERIOD ? ['#26E7A6'] : ['#008FFB'];
    const chartOptions: ApexOptions = React.useMemo(() => ({
        chart: { id: 'dashed-line-chart', toolbar: { show: false }, zoom: { enabled: false } },
        xaxis: {
            type: 'category',
            categories: xAxis,
            labels: {
                show: true,
                formatter: function (value: any) {
                    const date = new Date(value);
                    if (granularity === PT2H) {
                        return formatCustomDate(value);
                    } else {
                        return formatDateToLexicographicalOrder(date, timezone);
                    }
                },
            }
        },
        stroke: { width: 3, curve: 'straight', dashArray: id === PREVIOS_PERIOD ? 5 : 0 },
        markers: { size: 5 },
        colors: colors,
        yaxis: {
            opposite: false,
            title: {
                text: updateYAxisTitle(metricName ?? ""),
                rotate: -90,
                offsetX: 3,
                offsetY: 0,
                style: {
                    color: '#8C919A',
                    fontSize: '11px',
                    fontFamily: 'Noto Sans, sans-serif',
                    fontWeight: 700,
                    cssClass: 'apexcharts-yaxis-title',
                },
            },
        },
        legend: {
            show: true,
            position: 'bottom',
            markers: { fillColors: ['#26E7A6'] },
            fontSize: '12px', 
            fontFamily: 'Noto Sans, sans-serif',
            fontWeight: 400,
            labels: { 
                colors: ['#333'], 
            },
            showForSingleSeries: true
        },
        dataLabels: {
            enabled: false,
            formatter: function (val: any, opts: any) {
                return val;
            }
        },
    }), [data]);
    const series = [{
        name: data?.name ?? '',
        data: xAxis.map((dateString: any) => {
            const categoryDate = moment.utc(dateString);
            const dataPoint = data.data.find((point: any) => {
                const pointDate = moment.utc(point.x);
                return pointDate.isSame(categoryDate);
            });
            return dataPoint ? dataPoint.y : null;
        }),
    }];
    return (
        <div style={{ height: DEFAULT_HEIGHT }}><ReactApexChart options={chartOptions} series={series} type={type} height={DEFAULT_HEIGHT} /></div>
    );
};
export default SynchronizedChartItem;